<template src="./Procedures.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  props: {
    itemId: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.$store.dispatch("lookups/getLookups");
    this.$store
      .dispatch("doctorsAppointments/getForProcedures", this.itemId)
      .then((res) => {
        this.vm.fileNo = res.fileNo;
        this.vm.fullName = res.fullName;
        this.vm.appointmentDate = res.appointmentDate;
        this.vm.gender = res.gender;
        this.vm.birthDate = res.birthDate;
        this.vm.skinIssues = res.skinIssues;

        this.vm.fileName = res.appointmentsProcedure.fileName;
        this.vm.diseases = res.diseases;
        this.vm.procedures = res.procedures;
        if (res.appointmentsProcedure != null) {
          this.vm.treatmentPlan = res.appointmentsProcedure.treatmentPlan;
          this.vm.diagnosisSummary = res.appointmentsProcedure.diagnosisSummary;
        }
      }).catch(() => { });
  },
  computed: {
    age() {
      if (this.vm.birthDate != null) {
        const birthDate = new Date(this.vm.birthDate)
        const today = new Date()

        let diffYears = Math.floor(
          (today.getTime() - birthDate.getTime()) / (1000 * 60 * 60 * 24 * 365.25)
        )
        let diffMonths = (today.getFullYear() - birthDate.getFullYear()) * 12
        diffMonths -= birthDate.getMonth() + 1
        diffMonths += today.getMonth()
        diffMonths += 1

        let diffDays = Math.ceil(
          (today.getTime() - birthDate.getTime()) / (1000 * 60 * 60 * 24)
        )

        var Age = diffYears > 0 ? diffYears : diffMonths > 0 ? diffMonths : diffDays
        var AgeType = diffYears > 0 ? 'سنة' : diffMonths > 0 ? 'شهر' : 'يوم'
        return `${Age} ${AgeType}`

      }
      return ""
    },
    diseasesTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.DiseasesTypes
      );
    },
    skinIssuesTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.SkinIssuesTypes
      );
    },
    headers() {
      return [
        { text: "تاريخ الموعد", value: 'appointmentDate' },
        { text: "اسم الطبيب", value: 'doctorName' },

        { text: "الإجراءات", value: 'actions', sortable: false },
      ]
    },

  },
  data() {
    return {
      file: null,
      item: {},
      expanded: [],


      vm: {
        file: null,
        birthDate: null,
        procedures: [],
        diseases: [],
        skinIssues: []

      },
      formDialog: false,

    };
  },
  methods: {
    onFileChange() {
      this.vm.file = this.file;

    },
    confirm() {
      this.$store
        .dispatch("doctorsAppointments/UpdateProcedure", {
          id: this.itemId,
          payload: this.vm
        })
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    viewItem(item) {
      this.item = item;
      this.formDialog = true;

    },
    cancelFormDialog() {
      this.formDialog = false;
      this.item = {};
    },
    back() {
      this.$emit("back");
    },


    viewFile(id) {
      this.$store.dispatch("doctorsAppointments/getAttachment", id)
        .then(res => {
          const blob = new Blob([res.data], { type: res.headers["content-type"] });
          const url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        });
     
    }
  },
};
</script>